import React, { useEffect, useState } from 'react';
import { Paginate } from '@cokitchen/cokitchen-components';
import { UserType } from 'models/user.model';
import { IssueType } from 'models/issue.model';
import { apiService } from 'utils/api';
import Loader from 'components/base/loader';
import UserIssueCard from 'components/base/cards/user-issue-card';

const baseUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;

const UserIssues = ({ user }: { user: UserType }) => {
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [issues, setIssues] = useState<Partial<IssueType>[]>([]);

  const loadIssues = async (pageNo = 1) => {
    setLoading(true);
    const { id: user_id } = user;
    const res = await apiService.post(`cs/user/one/issues/${pageNo}`, {
      data: {
        user_id
      },
      baseUrl
    });
    const response = res?.data;
    const data = response?.data;

    const pageCount = Math.ceil(response?.total / 10);
    setPageCount(pageCount);
    setIssues(data?.data);
    setLoading(false);
  };

  const getSelectedPage = (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    loadIssues(pageNo);
  };

  useEffect(() => {
    loadIssues();
  }, []);

  return (
    <div className='pt-8 pb-3 space-y-6'>
      {loading ? (
        <Loader />
      ) : issues.length === 0 ? (
        <div className={`flex items-center justify-center h-full  font-semibold`}>
          No Issues To Show
        </div>
      ) : (
        <div className='grid lg:grid-cols-2 gap-6'>
          {issues?.map((issue) => (
            <UserIssueCard key={issue.id} item={issue} />
          ))}
        </div>
      )}
      <Paginate onPageChange={getSelectedPage} pageCount={pageCount} />
    </div>
  );
};

export default UserIssues;
